// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-VacancySection-module--cls1--1G7MY","cls2":"styles-VacancySection-module--cls2--1sHYo styles-VacancySection-module--cls1--1G7MY"};